import axios from 'axios';
import url from '../url';

export default class ActivityInfo {
  constructor({ activityId, userId, settings = {} } = {}) {
    this.activityId = activityId ?? null;
    this.userId = userId ?? null;
    this.settings = settings ?? {};
  }

  static fromResponse(resp) {
    if (!resp || !resp.data) return new ActivityInfo();
    return new ActivityInfo(resp.data);
  }

  toJSON() {
    return {
      activityId: this.activityId,
      userId: this.userId,
      settings: this.settings,
    };
  }

  // For compatibility with existing findroomByInfo(activityInfo)
  // which expects an axios-like { data: { settings: ... } }
  toAxiosShape() {
    return { data: this.toJSON() };
  }

  static async get(activityId) {
    const jwtToken = localStorage.getItem('jwtToken');
    const headers = jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {};
    const resp = await axios.get(`${url.backendHost}api/activityInfo/${activityId}` , {
      headers,
      withCredentials: true,
    });
    return ActivityInfo.fromResponse(resp);
  }

  static async create({ activityId, userId }) {
    const jwtToken = localStorage.getItem('jwtToken');
    const headers = jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {};
    const resp = await axios.post(`${url.backendHost}api/activityInfo/`, {
      activityId,
      userId,
    }, { headers, withCredentials: true });
    return ActivityInfo.fromResponse(resp);
  }

  static async update({ activityId, userId, settings }) {
    const jwtToken = localStorage.getItem('jwtToken');
    const headers = jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {};
    const resp = await axios.put(`${url.backendHost}api/activityInfo/${activityId}`, {
      activityId,
      userId,
      settings,
    }, { headers, withCredentials: true });
    return ActivityInfo.fromResponse(resp);
  }
}


